import { ManualPropositionPage } from './ManualPropositionPage';
export default ManualPropositionPage;